import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import {LoanService} from '../../shared-component/service/loan/loan.service';

@Component({
  selector: 'app-employeeDetails',
  templateUrl: './employeeDetails.component.html',
  styleUrls: ['./employeeDetails.component.scss']
})
export class EmployeeDetailsComponent implements OnInit {

  public empDetailsForm: FormGroup;

  private loanId: number;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private loanService: LoanService
  ) {
  }

  ngOnInit() {
    this.empDetailsForm = this.fb.group({
      employmentType: ['', Validators.compose([Validators.required])],
      employer: ['', Validators.compose([Validators.required])],
      monthlyIncome: ['', Validators.compose([Validators.required])],
      mfiStatus: [false]
    });

    this.activeRoute.data.subscribe((res: any) => {
      if (res.loanDetail && Object.keys(res.loanDetail).length) {
        this.loanId = res.loanDetail.id;
        if (res.loanDetail.Customer) {
          this.empDetailsForm.patchValue({
            employmentType: res.loanDetail.Customer.employmentType ? res.loanDetail.Customer.employmentType : '',
            employer: res.loanDetail.Customer.employer ? res.loanDetail.Customer.employer : '',
            monthlyIncome: res.loanDetail.Customer.monthlyIncome ? res.loanDetail.Customer.monthlyIncome : '',
            mfiStatus: res.loanDetail.Customer.mfiStatus ? res.loanDetail.Customer.mfiStatus : '',
          });
        }
      }
    });
  }

  get employer() {
    return this.empDetailsForm.get('employer');
  }

  get employmentType() {
    return this.empDetailsForm.get('employmentType');
  }

  get monthlyIncome() {
    return this.empDetailsForm.get('monthlyIncome');
  }

  get mfiStatus() {
    return this.empDetailsForm.get('mfiStatus');
  }
  onSubmit() {
    let formData = {
      employmentType: this.empDetailsForm.get('employmentType').value ? this.empDetailsForm.get('employmentType').value : null,
      employer: this.capitalize(this.empDetailsForm.get('employer').value) ? this.capitalize(this.empDetailsForm.get('employer').value) : null,
      monthlyIncome: this.empDetailsForm.get('monthlyIncome').value ? this.empDetailsForm.get('monthlyIncome').value : null,
      mfiStatus: this.empDetailsForm.get('monthlyIncome').value >= 25000 ? true : false,
    };

    this.loanService.employmentDetails(formData, this.loanId).subscribe(() => {
      this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/status`).then();
    }, (errors) => {
      for (let error of errors) {
        if (!this.empDetailsForm.get(error.field)) continue;
        this.empDetailsForm.get(error.field).setErrors({server: error.message});
      }
    });
  }

  goPrev() {
    this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/residence-details`).then();
  }

  capitalize(input) {
    if (input && input.trim()) {
      const trimmedInput = input.trim();
      const inputSplitBySpace = trimmedInput.split(" ");
      const capitalizedInputList = inputSplitBySpace.reduce((acc, val) => {
        return val ? acc.concat([val[0].toUpperCase() + val.slice(1, val.length)]) : acc;
      }, []);
      return capitalizedInputList.join(" ");
    }
    return input;
  }  
}
